<main class="policy-page">
  <section class="policy-hero">
    <div class="policy-container">
      <app-navigate-back class="mb-4"></app-navigate-back>
      <h1 class="policy-title">Refund &amp; Return</h1>
      <p class="policy-subtitle">The following terms are applicable for any products that You purchased with Us.</p>
    </div>
  </section>

  <section class="policy-body">
    <div class="policy-container policy-copy policy-stack">
      <section class="policy-section">
        <p class="policy-paragraph">
          Thank you for shopping at Varroc Connect.
        </p>
        <p class="policy-paragraph">
          The following terms are applicable for any products that You purchased with Us.
        </p>
      </section>

      <section class="policy-section">
        <h2 class="policy-section-title">Interpretation and Definitions</h2>
        <p class="policy-paragraph"><strong>Interpretation</strong></p>
        <p class="policy-paragraph">
          The words of which the initial letter is capitalized have meanings defined under the following conditions. The
          following definitions shall have the same meaning regardless of whether they appear in singular or in plural.
        </p>
      </section>

      <section class="policy-section">
        <h2 class="policy-section-title">Definitions</h2>
        <p class="policy-paragraph">For the purposes of this Return and Refund Policy:</p>
        <ul class="policy-list">
          <li>Company (referred to as either "the Company", "We", "Us" or "Our" in this Agreement) refers to Varroc Connect Private Limited (A Varroc Company), 4270, Elpro Compound, Chinchwadgaon, Pune, Maharashtra -411033</li>
          <li>Goods refer to the items offered for sale on the Service.</li>
          <li>Orders mean a request by You to purchase Goods from Us.</li>
          <li>Service refers to the Website.</li>
          <li>Website refers to Varroc Connect, accessible from store.mycariq.com</li>
        </ul>
        <p class="policy-paragraph">
          You means the individual accessing or using the Service, or the company, or other legal entity on behalf of which such individual is accessing or using the Service, as applicable.
        </p>
      </section>

      <section class="policy-section">
        <h2 class="policy-section-title">Your Order Cancellation Rights</h2>
        <p class="policy-paragraph">You are entitled to cancel Your Order within 2 days without giving any reason for doing so.</p>
        <p class="policy-paragraph">
          The deadline for cancelling an Order is 2 days from the date on which You received the Goods or on which a third party you have appointed, who is not the carrier, takes possession of the product delivered.
        </p>
        <p class="policy-paragraph">
          In order to exercise Your right of cancellation, You must inform Us of your decision by means of a clear statement. You can inform us of your decision by:
        </p>
        <p class="policy-paragraph">By email: <strong>{{SupportEmail}}</strong></p>
      </section>

      <section class="policy-section">
        <h2 class="policy-section-title">Conditions for Returns</h2>
        <p class="policy-paragraph">In order for the Goods to be eligible for a return, please make sure that:</p>
        <ul class="policy-list">
          <li>The Goods were purchased in the last 2 days</li>
          <li>The Goods are in the original packaging</li>
        </ul>
        <p class="policy-paragraph">The following Goods cannot be returned:</p>
        <ul class="policy-list">
          <li>The supply of Goods made to Your specifications or clearly personalized.</li>
          <li>The supply of Goods which according to their nature are not suitable to be returned, deteriorate rapidly or where the date of expiry is over.</li>
          <li>The supply of Goods which are not suitable for return due to health protection or hygiene reasons and were unsealed after delivery.</li>
          <li>The supply of Goods which are, after delivery, according to their nature, inseparably mixed with other items.</li>
        </ul>
        <p class="policy-paragraph">We reserve the right to refuse returns of any merchandise that does not meet the above return conditions in our sole discretion.</p>
        <p class="policy-paragraph">Only regular priced Goods may be refunded. Unfortunately, Goods on sale cannot be refunded. This exclusion may not apply to You if it is not permitted by applicable law.</p>
      </section>

      <section class="policy-section">
        <h2 class="policy-section-title">Returning Goods</h2>
        <p class="policy-paragraph">You are responsible for the cost and risk of returning the Goods to Us. You should send the Goods at the following address:</p>
        <p class="policy-paragraph">Varroc Connect Private Limited (A Varroc Company), 4270, Elpro Compound, Chinchwadgaon, Pune, Maharashtra - 411033</p>
        <p class="policy-paragraph">
          We cannot be held responsible for Goods damaged or lost in return shipment. Therefore, We recommend an insured and trackable mail service. We are unable to issue a refund without actual receipt of the Goods or proof of received return delivery.
        </p>
      </section>

      <section class="policy-section">
        <h2 class="policy-section-title">No Refund Policy</h2>
        <p class="policy-paragraph">No monetary refunds will be given for any reason.</p>
      </section>

      <section class="policy-section">
        <h2 class="policy-section-title">Contact Us</h2>
        <p class="policy-paragraph">
          If you have any questions about our Returns and Refunds Policy, please contact us at <strong>{{SupportEmail}}</strong>. Our customer service team is here to assist you.
        </p>
      </section>
    </div>
  </section>
</main>